import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, FormControl, FormGroup, Grid, Row } from 'react-bootstrap';
import queryString from 'query-string';
import SimpleErrorList from 'components/shared/errors/SimpleErrorList';
import {
  getErrors,
  getPassword,
  getPasswordConfirmation,
} from 'selectors/client/set-password';
import { confirmPassword, updatePassword } from 'actions/client/set-password';
import TermsModal from 'components/shared/modal/TermsModal';
import LabeledCheckBox from 'components/shared/checkbox/LabeledCheckBox';

class SetPassword extends Component {
  state = {
    showTerms: false,
    termsAccepted: false,
  };

  handleChange = (attribute, event) => {
    this.props.dispatch(updatePassword(attribute, event.target.value));
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const params = queryString.parse(this.props.location.search);
    this.props.dispatch(
      confirmPassword(
        params.invitation_token,
        this.props.password,
        this.props.passwordConfirmation,
        this.state.termsAccepted
      )
    );
  };

  toggleShowTerms = () => {
    this.setState((state) => ({ showTerms: !state.showTerms }));
  };

  toggleTermsAccept = () => {
    this.setState((state) => ({ termsAccepted: !state.termsAccepted }));
  };

  render() {
    return (
      <div className="client">
        <TermsModal
          show={this.state.showTerms}
          onHide={this.toggleShowTerms}
          invited
        />
        <Grid>
          <Row>
            <Col md={6} mdOffset={3}>
              <div className="title">
                <span>Create your password</span>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6} mdOffset={3}>
              <div className="form-container">
                <form onSubmit={this.handleSubmit}>
                  <Col md={12}>
                    <FormGroup>
                      <FormControl
                        type="password"
                        className="input"
                        value={this.props.password}
                        placeholder="Password"
                        onChange={this.handleChange.bind(this, 'password')}
                        required
                      />
                    </FormGroup>
                  </Col>

                  <Col md={12}>
                    <FormGroup>
                      <FormControl
                        type="password"
                        className="input"
                        value={this.props.passwordConfirmation}
                        placeholder="Password confirmation"
                        onChange={this.handleChange.bind(
                          this,
                          'passwordConfirmation'
                        )}
                        required
                      />
                    </FormGroup>
                  </Col>

                  {this.props.errors.length > 0 && (
                    <Col md={12}>
                      <SimpleErrorList errors={this.props.errors} />
                    </Col>
                  )}
                  <Col md={12}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        marginBottom: 10,
                      }}
                    >
                      <LabeledCheckBox
                        checked={this.state.termsAccepted}
                        onChange={this.toggleTermsAccept}
                        id="terms-and-conditions-checkbox"
                      />
                      <span>
                        I accept the
                        <a
                          style={{ cursor: 'pointer' }}
                          onClick={this.toggleShowTerms}
                        >
                          {' '}
                          Terms and conditions
                        </a>
                      </span>
                    </div>
                  </Col>
                  <Col md={12}>
                    <FormGroup>
                      <input
                        type="submit"
                        className={`btn-select btn-${
                          this.state.termsAccepted ? 'orange' : 'gray'
                        }`}
                        value="Confirm"
                        disabled={!this.state.termsAccepted}
                      />
                    </FormGroup>
                  </Col>
                </form>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    errors: getErrors(state),
    password: getPassword(state),
    passwordConfirmation: getPasswordConfirmation(state),
  };
})(SetPassword);



// WEBPACK FOOTER //
// ./src/components/client/user-invitations/SetPassword.js